import styled from 'styled-components'
import { Media, mbSize } from '../../theme'
import { Link } from 'gatsby'

export const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background: #181818;
  min-width: max-content;
  position: relative;
  ${Media.lessThan(Media.small)} {
    height: fit-content;
    left: unset;
  }
`

export const FooterWrap = styled.div`
  width: 1200px;
  ${Media.lessThan(Media.small)} {
    width: 100vw;
    padding: 0 ${mbSize(48)};
  }
`

export const FooterUpWrap = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 80px 0;
  ${Media.lessThan(Media.small)} {
    flex-direction: column-reverse;
    padding: ${mbSize(48)} 0 ${mbSize(120)} 0;
  }
`

export const FooterUpDivider = styled.div`
  position: relative;
  width: 1px;
  margin: -80px 0;
  border-left: 1px solid #2c303b;
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`

export const FooterUpLeftWrap = styled.div`
  margin-top: 80px;
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(120)};
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

export const FooterLogo = styled(Link)`
  height: fit-content;
  > img {
    width: 278px;
    cursor: pointer;
    ${Media.lessThan(Media.small)} {
      width: ${mbSize(480)};
    }
  }
`

export const FooterTitle = styled.div`
  font-size: 13px;
  color: #ffffff;
  margin-top: 16px;
  letter-spacing: 0%;
  font-weight: 400;
  width: 278px;
  text-align: justify;
  &::after {
    content: '';
    display: inline-block;
    width: 100%;
  }
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(20)};
    margin-top: ${mbSize(24)};
    width: ${mbSize(480)};
    line-height: ${mbSize(32)};
  }
`

export const FacebookWrap = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 66px;
  padding: 0 16px;
  border-radius: 4px;
  border: 1px solid #2c303b;
  ${Media.lessThan(Media.small)} {
    width: 100%;
    margin-top: ${mbSize(24.5)};
    height: ${mbSize(99)};
    padding: 0;
    justify-content: center;
  }
`

export const FacebookScore = styled.img`
  width: 45px;
  height: 24px;
`

export const FacebookStar = styled.img`
  width: 30px;
  height: 24px;
  margin-left: 8px;
`

export const FacebookRoundIcon = styled.img`
  width: 45px;
  height: auto;
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(67.5)};
  }
`

export const FacebookTitle = styled.div`
  font-size: 12px;
  color: #a3a3a3;
  text-transform: uppercase;
  letter-spacing: -0.4px;
  margin-left: 16px;
`

export const FacebookDesc = styled.div`
  display: none;
`

export const AssociationWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  ${Media.lessThan(Media.small)} {
    flex-direction: row;
    flex-wrap: wrap;
    gap: unset;
    align-items: flex-start;
    margin-top: ${mbSize(48.5)};
    width: 100%;
  }
`

export const AssociationCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 66px;
  padding: 0 16px;
  border-radius: 4px;
  border: 1px solid #2c303b;
  background: #181818;
  ${Media.lessThan(Media.small)} {
    height: ${mbSize(99)};
    justify-content: center;
    padding: 0;
    &.tpn {
      width: ${mbSize(270)};
      margin-right: ${mbSize(24)};
    }
    &.blender {
      width: ${mbSize(360)};
    }
  }
`

export const AssociationDivider = styled.div`
  width: 1px;
  height: 24px;
  margin: 0 16px;
  border-left: 1px solid #2c303b;
  ${Media.lessThan(Media.small)} {
    margin: 0 ${mbSize(24)};
  }
`

export const AssociationText = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #a3a3a3;
  text-transform: uppercase;
  letter-spacing: -0.4px;
  width: max-content;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(18)};
    line-height: ${mbSize(24)};
  }
`

export const TNPImg = styled.img`
  width: 28px;
  height: auto;
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(42)};
  }
`

export const BlenderImg = styled.img`
  width: 30px;
  height: auto;
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(45)};
  }
`

export const SocialMedia = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  width: 280px;
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(40)};
    width: ${mbSize(480)};
  }
`

export const LinkIcon = styled.a`
  width: fit-content;
  height: fit-content;
  > svg {
    transition: all 0.3s;
    fill: #a3a3a3;
    &:hover {
      fill: #f3512b;
    }
  }
`

export const FooterUpCenterWrap = styled.div`
  width: 770px;
  display: grid;
  grid-template-columns: repeat(3, max-content);
  justify-content: space-between;
  column-gap: 130px;
  row-gap: 40px;
  ${Media.lessThan(Media.small)} {
    display: flex;
    flex-direction: column;
    row-gap: ${mbSize(48)};
    width: 100%;
  }
`

export const LinkListWrap = styled.div<{ $marginTop?: number }>`
  display: flex;
  flex-direction: column;
  margin-top: ${({ $marginTop }) => ($marginTop ? `${$marginTop}px` : 'unset')};
  ${Media.lessThan(Media.small)} {
    margin-top: ${({ $marginTop }) => ($marginTop ? `${mbSize($marginTop)}` : 'unset')};
    border-bottom: 1.5px solid #2c303b;
  }
`

export const LinkListTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  line-height: 1;
  font-weight: 500;
  color: #fff;
  padding-bottom: 20px;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(28)};
    padding-bottom: ${mbSize(40)};
  }
`

export const LinkListExpandIcon = styled.span<{ $isOpen?: boolean }>`
  display: none;
  ${Media.lessThan(Media.small)} {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: ${mbSize(16)};
    width: ${mbSize(28)};
    height: ${mbSize(28)};
    transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
    transition: transform 0.2s ease-out;
    > svg {
      width: 9px;
      height: 5px;
    }
  }
`

export const LinkItem = styled.div`
  color: #a3a3a3;
  font-size: 14px;
  line-height: 28px;
  font-weight: 400;
  transition: all 0.3s;
  &:hover {
    color: #fb6244;
  }
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(28)};
    line-height: ${mbSize(56)};
    &:last-child {
      margin-bottom: ${mbSize(40)};
    }
  }
`

export const ContactItem = styled.div`
  color: #a3a3a3;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: 28px;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(28)};
    margin-bottom: ${mbSize(56)};
    line-height: ${mbSize(56)};
  }
`

export const MessageUsIconWrap = styled.div`
  display: flex;
  justify-content: space-between;
  width: 170px;
  ${Media.lessThan(Media.small)} {
    width: 60%;
    margin-bottom: ${mbSize(40)};
  }
`

export const MessageUsIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  transition: all 0.3s;
  > svg {
    &.stroke {
      path {
        stroke: #a3a3a3;
      }
    }
    &.fill {
      path {
        fill: #a3a3a3;
      }
    }
  }
  &:hover {
    > svg {
      &.stroke {
        path {
          stroke: #f3512b;
        }
      }
      &.fill {
        path {
          fill: #f3512b;
        }
      }
    }
  }
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(60)};
    height: ${mbSize(60)};
    border-radius: ${mbSize(20)};
    > svg {
      width: ${mbSize(37)};
    }
    &.telegram {
      svg {
        position: relative;
        left: -2px;
      }
    }
  }
`

export const FooterUpRightWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  height: 360px;
  border-radius: 12px;
  background: #222222;
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(60)};
    width: ${mbSize(670)};
    height: ${mbSize(720)};
    border-radius: ${mbSize(24)};
  }
`

export const NewsletterTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 20px 0;
  ${Media.lessThan(Media.small)} {
    margin: ${mbSize(40)} 0;
    font-size: ${mbSize(40)};
  }
`

export const NewsletterDesc = styled.div`
  width: 260px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  text-align: center;
  margin-bottom: 30px;
  ${Media.lessThan(Media.small)} {
    margin-bottom: ${mbSize(60)};
    font-size: ${mbSize(24)};
    width: ${mbSize(520)};
  }
`

export const NewsletterForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const NewsletterInput = styled.input<{ $marginBottom?: number }>`
  font-family: MarkPro;
  font-size: 14px;
  width: 260px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #333333;
  outline: none;
  background: #181818;
  color: #fff;
  padding: 0 20px;
  margin-bottom: ${({ $marginBottom }) => ($marginBottom ? `${$marginBottom}px` : 'unset')};
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(24)};
    padding: 0 ${mbSize(40)};
    border-radius: ${mbSize(8)};
    &::placeholder {
      text-align: center;
    }
  }
`

export const NewsletterButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  width: 196px;
  height: 40px;
  border-radius: 20px;
  background: linear-gradient(180deg, #f3512b 0%, #f55c1e 100%);
  margin-top: 40px;
  transition: all 0.3s;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 10px 10px 0px #f3512b4d;
  }
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(392)};
    height: ${mbSize(81)};
    border-radius: ${mbSize(40)};
    margin-top: ${mbSize(80)};
    font-size: ${mbSize(32)};
  }
`

export const FooterDivider = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 1px;
  background: #2c303b;
  ${Media.lessThan(Media.small)} {
    position: relative;
    left: unset;
    transform: unset;
    width: 100%;
  }
`

export const FooterDownWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #666666;
  font-size: 14px;
  height: 166px;
  ${Media.lessThan(Media.small)} {
    padding: ${mbSize(120)} 0;
    flex-direction: column;
    height: max-content;
    font-size: ${mbSize(20)};
  }
`

export const FooterDownLeftWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 66px;
  color: #afafb0;
  font-size: 14px;
  ${Media.lessThan(Media.small)} {
    height: ${mbSize(96)};
    font-size: ${mbSize(20)};
    text-align: center;
  }
`

export const FooterDownLinkWrap = styled.div`
  > a {
    color: #afafb0;
    &:first-child {
      margin-right: 32px;
    }
  }
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(31)};
  }
`
